import {ApiClientCommunication, Utils} from 'neo-common';
import {PlayerLogErrorResponse} from '../Responses/PlayerLogErrorResponse';

/**
 * @class ProgressiveBonusGetInfoRequest - Game client uses service to get current information about selected progressive bonus game by bonusId.
 */
export class PlayerLogErrorRequest extends ApiClientCommunication.RequestBase<PlayerLogErrorResponse> {

    /**
     * @property message - Error message.
     */
    message: string;

    /**
     * @property customData - custom data.
     */
    customData: any;

    constructor(message: string, customData?: any) {
        super();

        if (Utils.isNullOrUndefined(message)) {
            throw new Error(`Argument "message" is required to be specified!`);
        }

        this.message = message;
        this.customData = customData;
    }

    createResponse(responseJson: ApiClientCommunication.Types.RawResponseType): PlayerLogErrorResponse {
        return new PlayerLogErrorResponse(responseJson);
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Requests/PlayerLogErrorRequest.ts
 **/